import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { RiApps2Line } from "react-icons/ri";
import { limpiarLocalStorage, obtenerLocalStorage } from "../../../shared/utils/funciones";
import { CONST_KEY_USUARIO_AUTENTICADO } from "../../constants/constanst-valores";
import { Modal } from "../../../shared/ui";
import { IdleTimer } from "../idleTimer/IdleTimer";
import { CONST_RUTA_LOGIN } from "../../constants/constants-rutas-codigos";

// Modal de aplicaciones del sidebar (navegar a otra app) y modal de sesión
// terminada por inactividad (IdleTimer).
export const SimpleDialog = (props) => {
  const { onClose, listaApps, open } = props;
  const navigate = useNavigate()

  // Obtener los valores de las variables CSS cuando el componente se monta
  const computedStyles = getComputedStyle(document.documentElement);


  const handleListItemClick = (app) => {

    const usuarioLS = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO)
    const token = usuarioLS?.token

    const urlApp = app?.url + "/conexionExterna/" + token

    limpiarLocalStorage(CONST_KEY_USUARIO_AUTENTICADO)
    // localStorage.removeItem("urlServer");
    // Abre la nueva ruta en una nueva ventana o pestaña
    window.location.replace(urlApp);
  };

  const [, setIsIdle] = useState(false);
  const idleTimerRef = useRef(null);

  const [show, setShow] = useState(false)

  const onIdle = () => {
    setIsIdle(true);
    setShow(true)
    // Puedes mostrar una alerta aquí u realizar cualquier acción que desees
    limpiarLocalStorage(CONST_KEY_USUARIO_AUTENTICADO);
  };

  const onAction = () => {
    setIsIdle(false);
  };

  return (
    <>
      {/* MODAL DE SESION TERMINADA */}
      <IdleTimer
        ref={idleTimerRef}
        timeout={1800000}
        // timeout={5000}
        onIdle={onIdle}
        onAction={onAction}
      />

      <Modal open={show} title="Sesión Terminada" onOpenChange={() => { }}>
        <div>Estimado usuario, su sesión ha terminado debido a la inactividad.</div>
        <div>Por favor, vuelva a iniciar sesión.</div>
        <div className="tw-mt-3 tw-text-end">
          <button
            className="btn btn-primario btn-sm"
            onClick={() => navigate(CONST_RUTA_LOGIN)}
          >
            Aceptar
          </button>
        </div>
      </Modal>

      {/* FIN MODAL DE SESION TERMINADA */}
      <Modal open={open} title="Aplicaciones" onOpenChange={(o) => { if (!o) onClose(); }}>
        <div className="popup-aplicaciones">
          <div className="tw-grid tw-grid-cols-3 tw-gap-2">
            {listaApps.map((app) => (
              <button
                type="button"
                key={app?.ModCod}
                onClick={() => handleListItemClick(app)}
                className="tw-flex tw-flex-col tw-items-center tw-gap-1 tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-2 tw-cursor-pointer hover:tw-bg-gray-100"
              >
                <span
                  className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-full tw-border tw-bg-white"
                  style={{
                    color: computedStyles?.getPropertyValue('--color-button-primario'),
                    borderColor: computedStyles?.getPropertyValue('--color-button-primario'),
                  }}
                >
                  <RiApps2Line size={20} />
                </span>
                <span className="tw-text-center tw-text-xs">{app?.name}</span>
              </button>
            ))}
          </div>
        </div>
      </Modal>
    </>

  );
}
